<template>
  <div :style="style" class="control-container">
    <div class="control-row title">
        <CktextComponent :rawHtml="control.data.data.title">    
        </CktextComponent>
        <div v-if="control.data.data.misc.required" class="required">*</div>
    </div>
    <div class="control-row">
        <CktextComponent :rawHtml="control.data.data.subtitle">    
        </CktextComponent>
    </div>
    <div class="control-row">
        <div v-for="(item, index) in control.data.data.options" :key="item.value" class="option-row">
            <div style="margin-right: 2rem;flex-shrink: 1;">
                <CktextComponent :rawHtml="item.label">    
                </CktextComponent>
            </div>
            <div><InputSwitch v-model="itemchecked[index]" /></div>
        </div>
    </div>   
  </div>
</template>

<script>
import InputSwitch from 'primevue/inputswitch';
import CktextComponent from '../CkText.vue';

export default {
  name: 'SwitchControl',
  components: {
    InputSwitch,
    CktextComponent
  },
  data(){
    return {
      style:'',
      itemchecked:[]
    }
  },
  props: {
    control: null
  },
  methods:{
    validateData(){
  
      this.submitted=true;

      this.valid=true;

      return {
        valid:this.valid,
        data:this.itemchecked,
        type:2
      };

    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);

    this.itemchecked=this.control.data.data.selection;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.control-container:last-child{
      margin-bottom: 0px;
  }
  .control-row{
      margin-bottom: 10px;
      text-align:left;
  }

  .title{
      display: flex;
  }
  .required{
    color:#f7363f;
  }   

  .option-row{
      display:flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
  }
</style>